import Dropzone from "react-dropzone";
import styles from './styles';
import {AxlReselect} from "axl-reactjs-ui";
import React from "react";
import {
    withStyles,
    Container, Grid, Box, Typography, Button
} from "@material-ui/core";
import {ModalDialog} from "../../Modal";
import {LoadingOverlay} from "../../LoadingOverlay";
import FileItem from "./components/FileItem";


const ClaimDocumentUpload = (props) => {
    const {
        files,
        onDropRejected,
        onDropAccepted,
        onDrop,
        maxSize,
        open,
        onSubmit,
        onCancel,
        classes,
        uploading,
        additionalAction,
        fileErrors,
        uploadErrors,
        claim,
        claimDocumentTypeOptions,
        claimUploadDocumentType,
        setClaimUploadDocumentType,
        handleStageFile,
        stagedFiles,
        removeStagedFile
    } = props;


    const {claim_number} = claim || {};
    const disableStageSubmit = files.length === 0 || fileErrors.length > 0 || !claimUploadDocumentType || uploading;
    const disableSubmit = stagedFiles.length === 0
    const displayErrors = [];
    if (fileErrors?.length > 0) {
        displayErrors.push(...fileErrors);
    }
    if (uploadErrors?.length > 0) {
        displayErrors.push(...uploadErrors);
    }


    return (
        <ModalDialog
            open={open}
            style={styles.claimDocumentUploadModal}
            hideClose={true}
            minWidth="750px"
            onClose={onCancel}
            onOk={onSubmit}
            okLabel={'SUBMIT'}
            title={`Submit Documents for Claim ${claim_number}`}
            additionalAction={additionalAction}
            classes={classes}
            error={displayErrors}
            disabledOk={disableSubmit}
        >
            <Container direction="column" className={classes.root}>
                {(uploading) && <LoadingOverlay color="#887fff"/>}
                <Grid item className={classes.subTitle}> Additional documents (ex. Invoice, photos) are required to complete claim processing.</Grid>
                <Grid container direction="row" style={{marginTop: '10px'}}>
                    <Grid item direction="row" style={{marginTop: '10px'}}>
                        <Dropzone accept={
                            {
                                'image/jpg': ['.jpg'],
                                'application/pdf':['.pdf']
                            }}
                                  multiple={false} maxSize={maxSize} onDrop={onDrop}
                                  onDropRejected={onDropRejected} onDropAccepted={onDropAccepted}>
                            {({getRootProps, getInputProps}) => (
                                <div {...getRootProps()}>

                                    <input {...getInputProps()} />
                                    <Grid container className={classes.action}>
                                        {files.length == 0 ?
                                            <Grid item>
                                                <Button compact disableElevation  variant="outlined" className={classes.uploadArea}>Upload a Document here</Button>
                                            </Grid>
                                            :
                                            <>
                                                <Grid container alignItems='center'>
                                                    <Grid item>
                                                        <Box className={classes.fileName}>{files[0].name}</Box>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                </div>
                            )}
                        </Dropzone>
                    </Grid>
                </Grid>
                <Grid item className={classes.groupControlSelect}>
                    <Grid container direction="row">
                        <Grid item xs={10}>
                        <AxlReselect
                            style={{width: '100%', height: '45px'}}
                            name='claim_upload_document_type'
                            value={claimUploadDocumentType}
                            onChange={(selectedType) => {
                                setClaimUploadDocumentType(selectedType ? selectedType.value : null);
                            }}
                            placeholder={'Select Document Type'} theme={`main`}
                            isClearable
                            options={claimDocumentTypeOptions}/>
                        </Grid>
                        <Grid item xs={2}>
                            <Button compact
                                    disabled={disableStageSubmit}
                                    variant="contained"
                                    disableElevation
                                    color="primary"
                                    className={classes.uploadAction}
                                    onClick={handleStageFile}>Upload</Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.instructions} direction="column">
                    <Grid item className='left-margin'>.pdf, .jpg formats are supported. File may not exceed 5MB per document </Grid>
                </Grid>
                <Grid container style={{marginTop: '40px'}} direction="column">
                    <Grid item>
                        <Typography className={classes.label}>Uploaded Files</Typography>
                    </Grid>
                    {
                        stagedFiles && stagedFiles.length > 0 &&
                                <Grid item container spacing={1}>
                                {
                                    stagedFiles.map((stagedFile, index) => {
                                        return (
                                                <FileItem key={index} file={stagedFile.file} removeFile={() => removeStagedFile(index)} classes={classes}/>
                                        );

                                    })
                                }
                            </Grid>
                    }
                </Grid>
            </Container>
        </ModalDialog>
    )


}

export default withStyles(styles)(ClaimDocumentUpload);